import React from 'react';
import DocTitle from 'react-document-title';
import Alert from '../Alert';
import {weeklyActivityApi} from '../../requests/weeklyActivity';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-11-02" → "Nov 2", read as a calendar date so no timezone moves it. */
function shortDate(iso) {
	const parts = String(iso || '').split('-');
	if (parts.length !== 3) return '';
	return MONTHS[parseInt(parts[1], 10) - 1] + ' ' + parseInt(parts[2], 10);
}

function weekLabel(week) {
	if (!week) return '';
	return shortDate(week.week_start) + ' – ' + shortDate(week.week_ending) + ', ' + String(week.week_ending).slice(0, 4);
}

/**
 * The Friday calls & meetings form an agent opens from their email. It sits
 * outside Root: there is no sign-in, the token in the link is the agent's own
 * and names the week. What is submitted adds to # of Calls and # of Meetings
 * on SUMMIT Buckets; opening the link again shows the figures and lets the
 * agent change them.
 */
export default class WeeklyActivity extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			week: null,
			calls: '',
			meetings: '',
			loading: true,
			saving: false,
			loadError: null,
			error: null,
			saved: false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		weeklyActivityApi.show(this.token()).then((week) => {
			this.setState({
				week,
				calls: week.calls === null || week.calls === undefined ? '' : String(week.calls),
				meetings: week.meetings === null || week.meetings === undefined ? '' : String(week.meetings),
				loading: false,
			});
		}).catch((err) => {
			this.setState({loading: false, loadError: err.message || 'This link could not be opened.'});
		});
	}

	token() {
		return (this.props.params && this.props.params.token) || '';
	}

	handleChange(e) {
		// Whole numbers only: a count of calls or meetings.
		this.setState({[e.currentTarget.name]: e.currentTarget.value.replace(/[^0-9]/g, ''), saved: false, error: null});
	}

	handleSubmit(e) {
		e.preventDefault();
		if (this.state.saving) return;

		const {calls, meetings} = this.state;
		if (calls === '' || meetings === '') {
			this.setState({error: 'Please enter both your calls and your meetings (0 if none).'});
			return;
		}

		this.setState({saving: true, error: null, saved: false});

		weeklyActivityApi.submit(this.token(), parseInt(calls, 10), parseInt(meetings, 10)).then((week) => {
			this.setState({week, saving: false, saved: true});
		}).catch((err) => {
			this.setState({saving: false, error: err.message || 'Your numbers could not be saved. Please try again.'});
		});
	}

	renderBody() {
		const {week, calls, meetings, loading, loadError, error, saving, saved} = this.state;

		if (loading) {
			return <p className='login-subtitle'>Loading…</p>;
		}

		if (loadError) {
			return <Alert type='error'>{loadError}</Alert>;
		}

		const firstName = week.agent_first_name ? week.agent_first_name : '';

		return (
			<div>
				<p className='login-subtitle'>
					{firstName ? firstName + ', please' : 'Please'} enter your total calls and meetings for the week of <strong>{weekLabel(week)}</strong>.
				</p>

				{saved ? (
					<p className='WeeklyActivity_done'>
						Thank you! Your calls and meetings for this week are saved. You can open this link again to change them.
					</p>
				) : null}

				{error ? <Alert type='error'>{error}</Alert> : null}

				<form onSubmit={this.handleSubmit} className='login-form' noValidate>
					<div className='form-field'>
						<label htmlFor='weekly-activity-calls'># of Calls</label>
						<input
							id='weekly-activity-calls'
							name='calls'
							type='text'
							inputMode='numeric'
							autoComplete='off'
							autoFocus={true}
							placeholder='0'
							value={calls}
							onChange={this.handleChange}
						/>
					</div>
					<div className='form-field'>
						<label htmlFor='weekly-activity-meetings'># of Meetings</label>
						<input
							id='weekly-activity-meetings'
							name='meetings'
							type='text'
							inputMode='numeric'
							autoComplete='off'
							placeholder='0'
							value={meetings}
							onChange={this.handleChange}
						/>
					</div>
					<button type='submit' className='login-button' data-busy={saving}>
						{week.submitted_at ? 'Update' : 'Submit'}
					</button>
				</form>

				{week.submitted_at && !saved ? (
					<p className='WeeklyActivity_note'>You already submitted this week. Submitting again replaces your numbers.</p>
				) : null}
			</div>
		);
	}

	render() {
		return (
			<DocTitle title='Weekly Calls & Meetings'>
				<main className='login-page WeeklyActivity'>
					<div className='login-card'>
						<div className='login-logo'>
							<img
								src={`/img/inline-dark-logo.png`}
								alt='Summit Logo'
								style={{maxWidth: '90%', height: 'auto', display: 'block', borderBottom: '1px solid #E0E0E0'}}
							/>
						</div>
						<h1 className='login-title'>Weekly Calls &amp; Meetings</h1>
						{this.renderBody()}
					</div>
				</main>
			</DocTitle>
		);
	}
}
